import React from 'react';
import { Calendar, Select, Button, Icon, DatePicker } from 'antd';
import moment from 'moment';
// Removed UnifiedHostCalendar.scss as it's now imported via index.scss in SpaceManagementLayout

const UnifiedHostCalendar = ({ bookings, visits, onSelectDate, onPanelChange, selectedDate, spaceTitle, mobileView }) => {
    
    // Normalizing data to keyed objects for faster lookup if they are arrays
    const normalizedBookings = Array.isArray(bookings) ? bookings.reduce((acc, curr) => {
        const date = moment(curr.bookingStartDate).format('DD-MM-YYYY');
        if (!acc[date]) acc[date] = [];
        acc[date].push(curr);
        return acc;
    }, {}) : bookings;

    const normalizedVisits = Array.isArray(visits) ? visits.reduce((acc, curr) => {
        const date = moment(curr.schedulerStartDate).format('DD-MM-YYYY');
        if (!acc[date]) acc[date] = [];
        acc[date].push(curr);
        return acc;
    }, {}) : visits;

    const getListData = (value) => {
        const dateString = value.format('DD-MM-YYYY');
        const listData = [];

        const daysBookings = normalizedBookings[dateString] || [];
        if (daysBookings.length > 0) {
             listData.push({ type: 'booking', content: `Bookings (${daysBookings.length})` });
        }

        const daysVisits = normalizedVisits[dateString] || [];
         if (daysVisits.length > 0) {
             listData.push({ type: 'visit', content: `Visits (${daysVisits.length})` });
        }

        return listData;
    };

    const dateCellRender = (value) => {
        const listData = getListData(value);
        return (
            <div className="events-cell">
                {listData.map((item) => (
                    <div key={item.type} className={`event-indicator ${item.type}`}>
                        <span className={`dot ${item.type}`}></span>
                        <span className="event-text">{item.content}</span>
                    </div>
                ))}
            </div>
        );
    };

    const headerRender = ({ value, type, onChange, onTypeChange }) => {
        const handlePrevYear = () => {
            const newValue = value.clone().subtract(1, 'year');
            onPanelChange ? onPanelChange(newValue) : onSelectDate(newValue);
        };
        const handleNextYear = () => {
            const newValue = value.clone().add(1, 'year');
            onPanelChange ? onPanelChange(newValue) : onSelectDate(newValue);
        };
        const handlePrevMonth = () => {
            const newValue = value.clone().subtract(1, 'month');
            onPanelChange ? onPanelChange(newValue) : onSelectDate(newValue);
        };
        const handleNextMonth = () => {
            const newValue = value.clone().add(1, 'month');
            onPanelChange ? onPanelChange(newValue) : onSelectDate(newValue);
        };

        return (
            <div className="calendar-custom-header">
                <div className="header-left">
                    <div className="nav-wrapper">
                        <Button onClick={handlePrevYear} className="nav-btn year-btn">
                            <Icon type="double-left" />
                        </Button>
                        <Button onClick={handlePrevMonth} className="nav-btn month-btn">
                            <Icon type="left" />
                        </Button>
                        <span className="current-month-year">{value.format('MMMM, YYYY')}</span>
                        <Button onClick={handleNextMonth} className="nav-btn month-btn">
                            <Icon type="right" />
                        </Button>
                        <Button onClick={handleNextYear} className="nav-btn year-btn">
                            <Icon type="double-right" />
                        </Button>
                    </div>
                </div>
                {spaceTitle && (
                    <div className="header-right">
                        <h2 className="space-title-inline">{spaceTitle}</h2>
                    </div>
                )}
            </div>
        );
    };

    const disabledDate = (current) => {
        // Can not select days before today
        return current && current < moment().startOf('day');
    };

    return (
        <div className="unified-host-calendar">
            <Calendar 
                disabledDate={disabledDate}
                headerRender={headerRender}
                dateCellRender={dateCellRender} 
                onSelect={onSelectDate}
                value={selectedDate}
                fullscreen={true}
            />
        </div>
    );
};

export default UnifiedHostCalendar;
